import { useEffect, useState } from 'react'

/* An idle slot comes within this long after load, or the wait ends anyway. */
const IDLE_TIMEOUT_MS = 1200

/**
 * True once the page has loaded and the main thread has had an idle slot.
 * Decorative motion above the fold waits for it, so it never competes with
 * the first render and the largest paint.
 *
 * @returns {boolean}
 */
export default function useAfterLoad() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let idle = 0
    let timer = 0
    const start = () => {
      if (window.requestIdleCallback) {
        idle = window.requestIdleCallback(() => setReady(true), { timeout: IDLE_TIMEOUT_MS })
      } else {
        timer = window.setTimeout(() => setReady(true), 0)
      }
    }
    if (document.readyState === 'complete') start()
    else window.addEventListener('load', start, { once: true })
    return () => {
      window.removeEventListener('load', start)
      if (idle) window.cancelIdleCallback(idle)
      if (timer) window.clearTimeout(timer)
    }
  }, [])

  return ready
}
